async function http<T>(url: string, config: RequestInit): Promise<T> {
  const response = await fetch(url, config);

  if (!response.ok) {
    throw new Error(`code:${response.status} statusText:${response.statusText}`);
  }

  return response.json().catch(() => ({}));
}

export async function get<T>(url: string, config?: RequestInit): Promise<T> {
  const init = { method: 'get', ...config };
  return await http<T>(url, init);
}

export async function post<T, U>(url: string, body: T, config?: RequestInit): Promise<U> {
  const init = { body: JSON.stringify(body), method: 'post', ...config };
  return await http<U>(url, init);
}
